import { handleActions } from 'redux-actions';
import { putData, getData, postData } from '../utils/request';
import { loginSuccess } from './auth';

const initialState = {
  profile_image: null,
  first_name: null,
  last_name: null,
  mobile: null,
  addresses: [
    {
      street_address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      moving_year: '',
      moving_month: ''
    }
  ],
  bank_name: null,
  institution_number: null,
  account_number: null,
  transit_number: null,
  newBankName: null,
  newInstitutionNumber: null,
  newAccountNumber: null,
  newTransitNumber: null,
  reason_for_delay: null,
  existing_uber_partner: null,
  uberx_status: null,
  uber_token: null,
  status: null,
  deposit_paid: null,
  driver_id: null,
  connected_uber_email: null,
  via_status: null,
  operating_city: null
};

const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
const UPDATE_INFO = 'UPDATE_INFO';
const UPDATE_PROFILE_PIC = 'UPDATE_PROFILE_PIC';
const PROFILE_RETRIEVED = 'PROFILE_RETRIEVED';

/** ******************* ACTIONS ******************** */

export const updateLocalStorage = (field, value) => ({
  type: [UPDATE_INFO],
  field,
  value
});

const updateAddress = address => ({
  type: [UPDATE_ADDRESS],
  address
});

const updateProfilePic = file => ({
  type: [UPDATE_PROFILE_PIC],
  file
});

const profileRetrieved = response => ({
  type: [PROFILE_RETRIEVED],
  response,
  operatingCity: response.operating_city
});

export const tryUpdateAddress = addresses => dispatch => {
  postData('addresses', addresses).then(() =>
    dispatch(updateAddress(addresses.addresses))
  ); // API requires the format - addresses: { addresses: [a, b, c]}, so we need to deconstruct it now
};

export const tryUpdateInfo = (field, value) => dispatch => {
  const body = {
    [field]: value
  };
  return putData('users', body)
    .then(response => dispatch(loginSuccess(response, dispatch)))
    .then(() => dispatch(updateLocalStorage(field, value)))
    .catch(e => {
      throw e;
    });
};

export const tryUpdatePassword = (password, confirmation) => {
  const body = {
    user: {
      password,
      password_confirmation: confirmation
    }
  };
  return putData('users', body).catch(e => {
    throw e;
  });
};

export const tryUpdateMobile = (field, value) => dispatch => {
  const body = {
    [field]: value
  };

  return putData('users', body)
    .then(() => dispatch(updateLocalStorage(field, value)))
    .catch(e => {
      throw e;
    });
};

export const tryUpdateImage = (field, value) => {
  const formData = new FormData();
  formData.append(field, value);
  return putData('users', formData, 1).catch(e => {
    throw e;
  });
};

export const tryUpdateProfilePic = file => dispatch => {
  dispatch(updateProfilePic(file));
};

export const retrieveProfile = () => dispatch => {
  getData('users').then(response => {
    dispatch(profileRetrieved(response));
  });
};

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [UPDATE_ADDRESS]: (state, { address }) => ({
      ...state,
      addresses: [...address, ...state.addresses]
    }),

    [UPDATE_INFO]: (state, { field, value }) => ({
      ...state,
      [field]: value
    }),

    [UPDATE_PROFILE_PIC]: (state, { file }) => ({
      ...state,
      profilePic: file
    }),

    [PROFILE_RETRIEVED]: (state, { response }) => ({
      ...state,
      ...response
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/profile.js